import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { user, usersSlice, usersState } from './UsersSlice'
import { addUserSlice } from './AddModal/AddModalSlice'

import TableActionBar from '../../components/TableActionBar/TableActionBar'

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader'
import { Confirm } from '../../components/Alerts/Alerts'
import AddModal from './AddModal/AddModal'
import { havePermission } from '../../services/hoc/permissions'
import { SortTable } from '../../components/Table/SortTable'
import { RowContainer } from '../../components/Table/row_container'

import { useAPI } from '../../services/hoc/useAPI'
import { AxiosError } from 'axios'
import { useNotification } from '../../services/usenotification'

const Users =  () => {

    // Translation
    const t = useTranslation()
    const {alertError500} =useNotification()

    // Redux
    const dispatch = useDispatch()
    const [pagesInfo,setPagesInfo]=useState({page:1,lastPage:1})
    const state = useSelector( ( state: { users: usersState } ) => state.users )
    
    // Hooks

const ENDPOINTS = useAPI()

    const search = (value: string) => {
      
        dispatch( usersSlice.actions.reset() )
        fetchData(1,8,Boolean(value)?value:'')
    }

    // Fetch Data
    const fetchData = useCallback((page: number, page_size: number = 10,keyword='') => {

        dispatch( usersSlice.actions.setIsFetching( true ) )

        ENDPOINTS.users().index({ page, page_size, keyword })
        .then((response: any) => {
            let users: user[] = response.data.data.users.map((user: any): user => ({
                employee: user.employee,
                id: user.id,
                name: user.employee.name,
                email: user.email,
                role: user.role
            }))
            
            dispatch( usersSlice.actions.addUsers( users ) )
            dispatch( usersSlice.actions.setHasMore( page < Number(response.data.data.last_page) ) )
    
            if( !state.isLoaded )
                dispatch( usersSlice.actions.setIsLoaded( true ) )
        })
        .catch((err:AxiosError)=> {
               dispatch( usersSlice.actions.setIsFetching( false ) )
               alertError500(err)
        })
    },[dispatch,ENDPOINTS,state.isLoaded,])

const actions =(user:user)=>(
    <div className="show-on-hover">
                            { havePermission("Edit User") ?
                            <i className="icon-edit" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                                e.stopPropagation()
                                dispatch( addUserSlice.actions.setIsOpen(true) )
                                dispatch( addUserSlice.actions.setEditId(user.id) )
                                dispatch( addUserSlice.actions.set({
                                    email: user.email,
                                    employee: user.employee,
                                    password: "",
                                    role: user.role
                                }) )
                            } } /> : "" }
                            { user.id > 1 && havePermission("Delete User") ?
                            <i className="icon-delete" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                                e.stopPropagation()
                                Confirm({
                                    message: t("delete_confirmation"),
                                    onConfirm: () => remove(user.id)
                                })
                            }} /> : "" }
                        </div>
)

const rows =()=>{
    return state.users.map((user,index)=>{
        return (
            <RowContainer 
            item_id={user.id.toString()}
            tr_index={index}
            onSelect={toggleSelectedId}
            state_length={state.users.length}
            key={index}
            columns={[
                user.name,
                user.email,
                user.role?.name,
                actions(user)

            ]}
            />
        )
    })
}
    // Toggle Selected id
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const toggleSelectedId = (id: number) => {
        if(!havePermission("Delete User"))
        if(Number(id) === 1)
            return
        let index = selectedIds.findIndex(selectedId => selectedId === id)
        if( index !== -1 ) {
            setSelectedIds(selectedIds.filter(selectedId => selectedId !== id))
        } else
            setSelectedIds([...selectedIds, id])
    }

    // Delete
    const remove = (id?: number) => {
        
        let ids = id ? [id] : selectedIds.map(x => +x)
        dispatch( usersSlice.actions.setIsLoading(true) )
        ENDPOINTS.users().delete({ ids })
        .then(() => {
            setSelectedIds([])
            dispatch( usersSlice.actions.setIsLoading(false) )
            dispatch( usersSlice.actions.deleteUsers(ids) )
        }).
        catch((err:AxiosError)=>{
             dispatch( usersSlice.actions.setIsLoading(false) )
             alertError500(err)
        })

    }

    // First fetch
    useEffect(() => {
        if( !state.isFetching )
            fetchData(1)
    }, [])
//console.log('state',state)
    return(
        <>
            { state.isLoaded ?
            <>
                { state.isLoading ? <WhiteboxLoader /> : ""}
                <TableActionBar
                    title={t("users")}
                    search={search}
                    showFilter={false}
                    showDelete={selectedIds.length > 0}
                    delete={() => {
                        Confirm({
                            message: t("delete_confirmation"),
                            onConfirm: () => remove()
                        })
                    }}
                    addText={t("add_to_users")}
                    add={ havePermission("Add User") ? () => dispatch( addUserSlice.actions.setIsOpen(true) ) : undefined }
                    />
{/*                 
                <DashboardTable
                 
                    header={[ t("name"), t("email"), t("role"), "" ]}
                    body={generateData()}
                    onSelect={toggleSelectedId}
                    hasMore={state.hasMore}
                    loadMore={fetchData}
                    pagesInfo={pagesInfo}
                    setPagesInfo={setPagesInfo}
                    /> */}
                    <SortTable
                    header={[ t("name"), t("email"), t("role"), "" ]}
                    state={state.users}
                    onSelect={toggleSelectedId}
                    hasMore={state.hasMore}
                    loadMore={fetchData}
                    pagesInfo={pagesInfo}
                    setPagesInfo={setPagesInfo}
                    
                    >
                        <>
                        {
rows()
                        }
                        </>
                    </SortTable>
                <AddModal />
                
            </> : <div className="center"><EllipsisLoader /></div> }
        </>
    )

}

export default Users; 